<template>
  <div>
    <template v-if="!isFreeSubscriptionActive || isFreeSubscriptionActive && isBlueBlockActive">
      <div v-if="!fetching" :class="['star-rating-widget']">
        <div v-if="starDescriptionText" class="columns is-mobile is-marginless is-hidden-tablet">
          <div class="column hero">
            <div class="hero-body with-stars">
              <div class="container is-fluid">
                <p class="is-size-2 has-text-weight-bold has-text-centered" v-text="finalScore"></p>
                <p class="has-text-centered is-size-6"><rating :enlarge-mobile="enlargeMobile" :stars="getStarAverageWholeNumber" :shrink="starDescriptionText" ></rating></p>
                <p class="is-size-6 has-text-centered">AVG RATING</p>
              </div>
            </div>
          </div>
        </div>
        <div class="columns is-mobile is-marginless">
          <div v-if="!starDescriptionText" class="column is-4 hero">
            <div class="hero-body">
              <div class="container is-fluid">
                <p class="is-size-7 has-text-weight-bold has-text-centered">AVERAGE STAR</p>
                <p class="is-size-7 has-text-centered">RATING OUT OF 5</p>
                <p class="is-size-1 has-text-weight-bold has-text-centered" v-text="finalScore"></p>
                <p class="is-size-7 has-text-centered">FROM <span class="has-text-weight-bold">{{ totalReviews }}</span></p>
                <p class="is-size-7 has-text-centered">REVIEWS</p>
              </div>
            </div>
          </div>
          <div v-if="starDescriptionText" class="column is-hidden-mobile is-4 hero">
            <div class="hero-body with-stars">
              <div class="container is-fluid">
                <p class="is-size-2 has-text-weight-bold has-text-centered" v-text="finalScore"></p>
                <p class="has-text-centered is-size-7"><rating :stars="getStarAverageWholeNumber" :shrink="starDescriptionText" ></rating></p>
                <p class="is-size-6 has-text-centered">AVG RATING</p>
              </div>
            </div>
          </div>
          <div class="column">
            <!-- FIVE STARS -->
            <div class="columns is-mobile is-gapless level">
              <div v-if="!starDescriptionText" class="column is-3-mobile is-3-tablet level-item">
                <p class="is-size-7">
                <span class="icon">
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                </span>
                </p>
              </div>
              <div v-if="starDescriptionText" class="column is-3-mobile is-1-tablet level-item">
                <p class="is-size-6">5 Star</p>
              </div>
              <div :class="['column is-6-mobile', { 'is-7-tablet' : !starDescriptionText }, { 'is-5-tablet' : starDescriptionText },'level-item']">
                <p class="is-size-7"><progress :class="['progress is-five', { 'is-small': smallBars }]" :value="percentageFiveStars" max="100">{{ percentageFiveStars }}&#37;</progress></p>
              </div>
              <div :class="[{ 'column is-2 level-item': !starDescriptionText}, { 'column is-3 level-item' : starDescriptionText }]">
                <p :class="['is-size-7', { 'bigger-percentage': !smallBars }]">&nbsp;&nbsp;{{ five }}&nbsp;({{ percentageFiveStars }}&#37;)</p>
              </div>
            </div>
            <!-- FOUR STARS -->
            <div class="columns is-mobile is-gapless level">
              <div v-if="!starDescriptionText" class="column is-3-mobile is-3-tablet level-item">
                <p class="is-size-7">
                <span class="icon">
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                </span>
                </p>
              </div>
              <div v-if="starDescriptionText" class="column is-3-mobile is-1-tablet level-item">
                <p class="is-size-6">4 Star</p>
              </div>
              <div :class="['column is-6-mobile', { 'is-7-tablet' : !starDescriptionText }, { 'is-5-tablet' : starDescriptionText },'level-item']">
                <p class="is-size-7"><progress :class="['progress is-four', { 'is-small': smallBars }]" :value="percentageFourStars" max="100">{{ percentageFourStars }}&#37;</progress></p>
              </div>
              <div :class="[{ 'column is-2 level-item': !starDescriptionText}, { 'column is-3 level-item' : starDescriptionText }]">
                <p :class="['is-size-7', { 'bigger-percentage': !smallBars }]">&nbsp;&nbsp;{{ four }}&nbsp;({{ percentageFourStars }}&#37;)</p>
              </div>
            </div>
            <!-- THREE STARS -->
            <div class="columns is-mobile is-gapless level">
              <div v-if="!starDescriptionText" class="column is-3-mobile is-3-tablet level-item">
                <p class="is-size-7">
                <span class="icon">
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                </span>
                </p>
              </div>
              <div v-if="starDescriptionText" class="column is-3-mobile is-1-tablet level-item">
                <p class="is-size-6">3 Star</p>
              </div>
              <div :class="['column is-6-mobile', { 'is-7-tablet' : !starDescriptionText }, { 'is-5-tablet' : starDescriptionText },'level-item']">
                <p class="is-size-7"><progress :class="['progress is-three', { 'is-small': smallBars }]" :value="percentageThreeStars" max="100">{{ percentageThreeStars }}&#37;</progress></p>
              </div>
              <div :class="[{ 'column is-2 level-item': !starDescriptionText}, { 'column is-3 level-item' : starDescriptionText }]">
                <p :class="['is-size-7', { 'bigger-percentage': !smallBars }]">&nbsp;&nbsp;{{ three }}&nbsp;({{ percentageThreeStars }}&#37;)</p>
              </div>
            </div>
            <!-- TWO STARS -->
            <div class="columns is-mobile is-gapless level">
              <div v-if="!starDescriptionText" class="column is-3-mobile is-3-tablet level-item">
                <p class="is-size-7">
                <span class="icon">
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                </span>
                </p>
              </div>
              <div v-if="starDescriptionText" class="column is-3-mobile is-1-tablet level-item">
                <p class="is-size-6">2 Star</p>
              </div>
              <div :class="['column is-6-mobile', { 'is-7-tablet' : !starDescriptionText }, { 'is-5-tablet' : starDescriptionText },'level-item']">
                <p class="is-size-7"><progress :class="['progress is-two', { 'is-small': smallBars }]" :value="percentageTwoStars" max="100">{{ percentageTwoStars }}&#37;</progress></p>
              </div>
              <div :class="[{ 'column is-2 level-item': !starDescriptionText}, { 'column is-3 level-item' : starDescriptionText }]">
                <p :class="['is-size-7', { 'bigger-percentage': !smallBars }]">&nbsp;&nbsp;{{ two }}&nbsp;({{ percentageTwoStars }}&#37;)</p>
              </div>
            </div>
            <!-- ONE STAR -->
            <div class="columns is-mobile is-gapless level">
              <div v-if="!starDescriptionText" class="column is-3-mobile is-3-tablet level-item">
                <p class="is-size-7">
                <span class="icon">
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                </span>
                </p>
              </div>
              <div v-if="starDescriptionText" class="column is-3-mobile is-1-tablet level-item">
                <p class="is-size-6">1 Star</p>
              </div>
              <div :class="['column is-6-mobile', { 'is-7-tablet' : !starDescriptionText }, { 'is-5-tablet' : starDescriptionText },'level-item']">
                <p class="is-size-7"><progress :class="['progress is-one', { 'is-small': smallBars }]" :value="percentageOneStars" max="100">{{ percentageOneStars }}&#37;</progress></p>
              </div>
              <div :class="[{ 'column is-2 level-item': !starDescriptionText}, { 'column is-3 level-item' : starDescriptionText }]">
                <p :class="['is-size-7', { 'bigger-percentage': !smallBars }]">&nbsp;&nbsp;{{ one }}&nbsp;({{ percentageOneStars }}&#37;)</p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!hideLogo" class="columns is-mobile is-paddingless is-marginless">
          <div class="column is-paddingless is-2 is-offset-10">
            <figure class="image">
              <img src="/static/img/logo/hp-logo.svg" alt="Hellopeter.com" />
            </figure>
          </div>
        </div>
      </div>
      <img v-if="fetching" class="stats-loader" src="/static/img/loaders/spinner.svg" alt="fetching Business stats..." />
    </template>
    <template v-else>
      <div :class="{'is-visible': isFreeSubscriptionActive}"></div>
    </template>
  </div>
</template>
<script>
  /* eslint-disable indent,no-new,no-undef */
  import qs from 'qs'
  import axios from 'axios'
  import moment from 'moment'
  import Rating from './../components/Rating.vue'
  import misc from './../mixins/misc.js'

  export default {
    name: 'StarRatingWidgetFrame',
    components: {
      Rating
    },
    mixins: [misc],
    props: {
      slug: {
        type: String
      }
    },
    data () {
      return {
        enlargeMobile: true,
        finalScore: 0,
        totalReviews: 0,
        one: 0,
        two: 0,
        three: 0,
        four: 0,
        five: 0,
        starDescriptionText: false,
        smallBars: true,
        hideLogo: false,
        fetching: false
      }
    },
    computed: {
      percentageFiveStars () {
        if (this.five > 0) {
          return ((this.five / this.totalReviews) * 100).toFixed(0)
        }
        return 0
      },
      percentageFourStars () {
        if (this.four > 0) {
          return ((this.four / this.totalReviews) * 100).toFixed(0)
        }
        return 0
      },
      percentageThreeStars () {
        if (this.three > 0) {
          return ((this.three / this.totalReviews) * 100).toFixed(0)
        }
      },
      percentageTwoStars () {
        if (this.two > 0) {
          return ((this.two / this.totalReviews) * 100).toFixed(0)
        }
        return 0
      },
      percentageOneStars () {
        if (this.one > 0) {
          return ((this.one / this.totalReviews) * 100).toFixed(0)
        }
        return 0
      },
      getStarAverageWholeNumber () {
        if (this.finalScore > 0) {
          return parseInt(this.finalScore.toFixed(0))
        }
        return 0
      }
    },
    created () {
      this.fetching = true
      this.getData()
      this.getCurrentBusinessActiveSubscription()
    },
    methods: {
      getData () {
        const dateQuery = this.dateFilters(qs, moment, 'last_12_months', true)
        const widgetTracking = qs.stringify({
          track_activity_action: 'star.rating.view',
          track_activity_event: 'WidgetActivity'
        })
        axios.get(`/${this.slug}/reports/star-rating?${dateQuery}&${widgetTracking}`)
          .then(({data}) => {
            let newTotal = 0
            data.rows.forEach((row) => {
              switch (row[0]) {
                case '1 Star':
                  this.one = row[1]
                  break
                case '2 Stars':
                  this.two = row[1]
                  break
                case '3 Stars':
                  this.three = row[1]
                  break
                case '4 Stars':
                  this.four = row[1]
                  break
                case '5 Stars':
                  this.five = row[1]
                  break
                default:
                  break
              }
              newTotal += row[1]
            })
            this.finalScore = 0.0
            this.totalReviews = newTotal
            if (newTotal > 0) {
              let one = this.one
              let two = this.two * 2
              let three = this.three * 3
              let four = this.four * 4
              let five = this.five * 5
              this.finalScore = parseFloat(((one + two + three + four + five) / newTotal).toFixed(1))
            }
            this.fetching = false
          })
      }
    }
  }
</script>
<style scoped>
  .hero-body {
    padding: 0.5rem;
    background-color: #25b888;
  }

  .hero-body.with-stars {
    background-color: transparent;
    color: #58595B;
  }

  .hero-body.with-stars > .container.is-fluid > p:nth-child(3) {
    margin-top: 0.3rem;
  }

  .is-size-1 {
    line-height: 3.5rem;
  }

  .hero {
    color: #ffffff;
  }

  .has-text-weight-bold {
    font-weight: bolder;
  }

  .icon {
    width: auto;
  }

  .progress {
    border-radius: 0;
  }

  .columns.is-gapless.level:not(:last-child) {
    margin-bottom: 0.3rem;
  }

  .columns.is-gapless.level .is-size-7 {
    font-size: 0.5rem!important;
  }

  .columns.is-gapless.level .is-size-7.bigger-percentage {
    font-size: 1rem!important;
  }

  /* FIVE STAR PROGRESS BAR*/
  .progress.is-five::-webkit-progress-value {
    background-color: #25b888;
  }
  .progress.is-five::-moz-progress-bar {
    background-color: #25b888;
  }
  .progress.is-five::-ms-fill {
    background-color: #25b888;
  }

  /* FOUR STAR PROGRESS BAR*/
  .progress.is-four::-webkit-progress-value {
    background-color: #60c3a7;
  }
  .progress.is-four::-moz-progress-bar {
    background-color: #60c3a7;
  }
  .progress.is-four::-ms-fill {
    background-color: #60c3a7;
  }

  /* THREE STAR PROGRESS BAR*/
  .progress.is-three::-webkit-progress-value {
    background-color: #fbbb4e;
  }
  .progress.is-three::-moz-progress-bar {
    background-color: #fbbb4e;
  }
  .progress.is-three::-ms-fill {
    background-color: #fbbb4e;
  }

  /* TWO STAR PROGRESS BAR*/
  .progress.is-two::-webkit-progress-value {
    background-color: #f89b58;
  }
  .progress.is-two::-moz-progress-bar {
    background-color: #f89b58;
  }
  .progress.is-two::-ms-fill {
    background-color: #f89b58;
  }

  /* ONE STAR PROGRESS BAR*/
  .progress.is-one::-webkit-progress-value {
    background-color: #f05645;
  }
  .progress.is-one::-moz-progress-bar {
    background-color: #f05645;
  }
  .progress.is-one::-ms-fill {
    background-color: #f05645;
  }

  .columns.is-gapless.level > .column.is-3-mobile.is-3-tablet.level-item:first-child > .is-size-7 {
    color: #e5e5e5;
  }

  .columns.is-gapless.level:first-child .fas.fa-star {
    color: #25b888;
  }

  .columns.is-gapless.level:nth-child(2) .fas.fa-star:not(:last-child) {
    color: #60c3a7;
  }

  .columns.is-gapless.level:nth-child(3) .fas.fa-star:nth-child(1), .columns.is-gapless.level:nth-child(3) .fas.fa-star:nth-child(2), .columns.is-gapless.level:nth-child(3) .fas.fa-star:nth-child(3) {
    color: #fbbb4e;
  }

  .columns.is-gapless.level:nth-child(4) .fas.fa-star:nth-child(1), .columns.is-gapless.level:nth-child(4) .fas.fa-star:nth-child(2) {
    color: #f89b58;
  }

  .columns.is-gapless.level:nth-child(5) .fas.fa-star:nth-child(1) {
    color: #f05645;
  }

  figure > img {
    border-radius: 0;
    padding-right: 1rem;
  }

  figure.image {
    margin-bottom: 15px;
  }

  .one-px-border {
    border: 1px solid #cccccc;
  }

  .container.is-fluid {
    margin: 0;
  }

  .star-rating-widget {
    width: 507px!important;
    height: 198px!important;
    margin: 0!important;
  }

  .bigger-percentage {
    font-size: 1rem!important;
  }

  img.stats-loader {
    width: 40px;
    height: 40px;
    float: none;
    display: block;
    margin: 15% auto auto auto
  }
  .is-visible {
    background: rgb(49, 170, 225);
    height: 197px;
  }

</style>



// WEBPACK FOOTER //
// src/widgets/StarRatingWidgetFrame.vue